export type MatchResult<P extends Record<string, string> = Record<string, string>> = {
  path: string;
  params: P;
} | null;

export function match<P extends Record<string, string> = Record<string, string>>(pattern: string) {
  const keys: string[] = [];

  const escaped = pattern.replace(/([.+^${}()|[\]\\])/g, '\\$1');
  const src = '^' + escaped.replace(/\/:([A-Za-z0-9_]+)/g, (_: string, k: string) => {
    keys.push(k);
    return '/([^/]+)';
  }) + '$';

  const re = new RegExp(src, 'i');

  return (path: string): MatchResult<P> => {
    const m = re.exec(path);
    if (!m) return null;

    const params = {} as P;
    for (let i = 0; i < keys.length; i++) {
      (params as any)[keys[i]] = safeDecode(m[i + 1]);
    }
    return { path: m[0], params };
  };
}

function safeDecode(s: string): string {
  try {
    return decodeURIComponent(s);
  } catch {
    return s;
  }
}
